var Inpost = {};

Inpost.urls = {
  points: "https://api-pl-points.easypack24.net/v1/points?status=Operating&type=parcel_locker_superpop%2Cparcel_locker&max_distance=5000&per_page=200"
};

Inpost.searchPostBoxes = function (query, callback) {
  if (query.address) {
    GoogleMaps.geocodeAddress(query.address, function (results) {
      if (results === "ZERO_RESULTS") return;
      var location = results[0].geometry.location;
      $.get(Inpost.urls.points + "&relative_point=" + location.lat() + "%2C" + location.lng()).then(function (resp) {
        callback(resp);
      });
    });
  }
  if (query.latitude && query.longitude) {
    $.get(Inpost.urls.points + "&relative_point=" + query.latitude + "%2C" + query.longitude).then(function (resp) {
      callback(resp);
    });
  }
};